import { Component, ViewChild } from '@angular/core';
import { RequestDetail } from 'src/app/model/maker-checker/request-detail';
import { RequestType } from 'src/app/model/maker-checker/request-type';
import { messages } from 'src/app/resources/messages';
import { LoggingService } from 'src/app/services/logging.service';
import { MakerCheckerSearchPanelComponent } from '../maker-checker-search-panel/maker-checker-search-panel.component';

@Component({
  selector: 'maker-checker',
  templateUrl: './maker-checker.component.html',
  styleUrls: ['./maker-checker.component.scss']
})
export class MakerCheckerComponent {

  constructor(private loggingService: LoggingService) { }
  
  public msg = messages;
  public requestDetail!: RequestDetail & RequestType;
  @ViewChild(MakerCheckerSearchPanelComponent)
  searchPanelReference!: MakerCheckerSearchPanelComponent;

  public selectedRequest(data: RequestDetail  & RequestType) {
    this.requestDetail = data;
  }

  public reloadRequests(data: boolean) {
    if (data) {
      this.searchPanelReference.fetchData();
    }
  }
}
